import { render, staticRenderFns } from "./vipDetailIntegralDetail.vue?vue&type=template&id=5a0ea1c6&scoped=true"
import script from "./vipDetailIntegralDetail.vue?vue&type=script&lang=js"
export * from "./vipDetailIntegralDetail.vue?vue&type=script&lang=js"
import style0 from "./vipDetailIntegralDetail.vue?vue&type=style&index=0&id=5a0ea1c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0ea1c6",
  null
  
)

export default component.exports